import { useQuery } from "@tanstack/react-query";

import { ExistingDestination } from "@prequel/react";

import TransferReportService from "@/api/services/transfers_report";

export function useTransferReport(destinationId: ExistingDestination["id"] | undefined) {
  return useQuery({
    queryKey: ["reports", "transfers", destinationId],
    queryFn: () => TransferReportService.getTransferReport({ destinationID: destinationId }),
  });
}
